import fetch from '@/utils/fetch'
const BASE_API =  process.env.BASE_API
// 省市树结构
export function provinceCityAreaTreeList(data) {
  return fetch({
    url:BASE_API + '/area/listProvinceCityTree',
    method: 'post',
    data
  })
}
// 地区（省市县）
export function areaListGet(params) {
  return fetch({
    url:BASE_API + '/area/listByParentNo',
    method: 'get',
    params
  })
}

// 查看图片
export function getFile(data) {
  return fetch({
    url:BASE_API + '/file/getFileUrl',
    method: 'get',
    data
  })
}

// 删除文件
export function deleteFile(data) {
  return fetch({
    url:BASE_API + '/file/deleteFile',
    method: 'post',
    data
  })
}

export function departmentListGet(data) {
  return fetch({
    url:BASE_API + '/department/listForPage',
    method: 'post',
    data
  })
}
// 学员列表
export function employeeListGet(data) {
  return fetch({
    url:BASE_API + '/employee/listForPage',
    method: 'post',
    data
  })
}
// 客户管理
export function customerListQuery(data) {
  return fetch({
    url:BASE_API + '/customer/listForPage',
    method: 'post',
    data
  })
}

// 客户管理
export function customerListGet(data) {
  return fetch({
    url:BASE_API + '/customer/listForCustomerPage',
    method: 'post',
    data
  })
}
// 客户管理删除
export function customerListDel(data) {
  return fetch({
    url:BASE_API + '/customer/deleteCustomerInfo',
    method: 'post',
    data
  })
}
// 客户管理查看
export function getCustomerDetails(data) {
  return fetch({
    url:BASE_API + '/customer/getCustomerDetails',
    method: 'post',
    data
  })
}
// 客户管理编辑查看接口
export function getCustomerInfo(data) {
  return fetch({
    url:BASE_API + '/customer/getCustomerInfo',
    method: 'post',
    data
  })
}
// 客户管理编辑/根据主键id 获取 行业信息、标准化证书
export function getCustomerIndustry(data) {
  return fetch({
    url:BASE_API + '/customer/getCustomerIndustry',
    method: 'post',
    data
  })
}

// 客户管理编辑
export function editCustomerInfo(data) {
  return fetch({
    url:BASE_API + '/customer/editCustomerInfo',
    method: 'post',
    data
  })
}
// 查询企业相关负责人(原负责人)
export function forEmployeeList(data) {
  return fetch({
    url:BASE_API + '/customer/listForEmployee',
    method: 'post',
    data
  })
}
// 查询企业相关负责人(原负责人)
export function addTransferCustomer(data) {
  return fetch({
    url:BASE_API + '/customer/addTransferCustomer',
    method: 'post',
    data
  })
}

// 编辑查询第一步
export function getEmployee(params) {
  return fetch({
    url:BASE_API + '/employee/get'+"/"+params,
    method: 'get',
  })
}
// 编辑获取联系信息第二步
export function employeeGetByEmployeeId(params) {
  return fetch({
    url:BASE_API + '/employee/getByEmployeeId'+"/"+params,
    method: 'get',
  })
}
// 根据员工id获取学历教育3
export function employeeGetByEmployeeIdSch(params) {
  return fetch({
    url:BASE_API + '/employee/getByEmployeeIdSch'+"/"+params,
    method: 'get',
  })
}
// 获取专业信息/最后一步4
export function employeeGetByEmployeeIdPro(params) {
  return fetch({
    url:BASE_API + '/employee/getByEmployeeIdPro'+"/"+params,
    method: 'get',
  })
}

// 员工添加1
export function employeeAdd(data) {
  return fetch({
    url:BASE_API + '/employee/saveEmployee',
    method: 'post',
    data
  })
}
// 联系人信息添加2
export function employeeAdd2(data) {
  return fetch({
    url:BASE_API + '/employee/saveEmployeeExt',
    method: 'post',
    data
  })
}
// 员工学历教育添加3
export function employeeAdd3(data) {
  return fetch({
    url:BASE_API + '/employee/saveEmployeeeExtSch',
    method: 'post',
    data
  })
}

// 教育经历列表
export function hrEmployeeSchoolGet(data) {
  return fetch({
    url:BASE_API + '/hrEmployeeSchool/list',
    method: 'post',
    data
  })
}
// 员工学历教育添加3
export function employeeSchoolAdd(data) {
  return fetch({
    url:BASE_API + '/hrEmployeeSchool/saveEmployeeSchool',
    method: 'post',
    data
  })
}
// 教育经历详情
export function hrEmployeeSchoolGets(params) {
  return fetch({
    url:BASE_API + '/hrEmployeeSchool/get'+"/"+params,
    method: 'get',
    // data
  })
}
// 员工学历教育添加3
export function employeeSchoolEdit(data) {
  return fetch({
    url:BASE_API + '/hrEmployeeSchool/updateEmployeeSchool',
    method: 'post',
    data
  })
}
// 教育经历详情
export function hrEmployeeSchoolDel(params) {
  return fetch({
    url:BASE_API + '/hrEmployeeSchool/delete'+"/"+params,
    method: 'get',
    // data
  })
}
// 职业信息添加4
export function saveProfessionAdd(data) {
  return fetch({
    url:BASE_API + '/employee/saveProfession',
    method: 'post',
    data
  })
}
// 工作经历列表
export function hrEmployeeWorkGet(data) {
  return fetch({
    url:BASE_API + '/hrEmployeeWork/list',
    method: 'post',
    data
  })
}
// 教育经历详情
export function hrEmployeeWorkGets(params) {
  return fetch({
    url:BASE_API + '/hrEmployeeWork/get'+"/"+params,
    method: 'get',
    // data
  })
}
// 工作经历添加
export function addSaveEmployeeSchool(data) {
  return fetch({
    url:BASE_API + '/hrEmployeeWork/saveEmployeeSchool',
    method: 'post',
    data
  })
}
// 工作经历修改
export function editSaveEmployeeSchool(data) {
  return fetch({
    url:BASE_API + '/hrEmployeeWork/updateEmployeeSchool',
    method: 'post',
    data
  })
}
//工作经历删除
export function hrEmployeeWorkDel(params) {
  return fetch({
    url:BASE_API + '/hrEmployeeWork/delete'+"/"+params,
    method: 'get',
    // data
  })
}
//工作经历删除
export function employeeGet(params) {
  return fetch({
    url:BASE_API + '/employee/showById'+"/"+params,
    method: 'get',
    // data
  })
}
// 根据id获取银行卡信息
export function hrEmployeeBankGet(data) {
  return fetch({
    url:BASE_API + '/hrEmployeeBank/list',
    method: 'post',
    data
  })
}
// 银行账号添加
export function saveEmployeeBank(data) {
  return fetch({
    url:BASE_API + '/hrEmployeeBank/saveEmployeeBank',
    method: 'post',
    data
  })
}
// 银行账号修改
export function updateEmployeeBank(data) {
  return fetch({
    url:BASE_API + '/hrEmployeeBank/updateEmployeeBank',
    method: 'post',
    data
  })
}
//银行账号查看
export function getHrEmployeeBank(params) {
  return fetch({
    url:BASE_API + '/hrEmployeeBank/get'+"/"+params,
    method: 'get',
    // data
  })
}
//银行账号删除
export function hrEmployeeBankDel(params) {
  return fetch({
    url:BASE_API + '/hrEmployeeBank/delete'+"/"+params,
    method: 'get',
    // data
  })
}
//学员管理高级导出查看
export function employeeExportKey(params) {
  return fetch({
    url:BASE_API + '/employee/exportKey',
    method: 'get',
    params
  })
}
//学员管理高级导出确定
export function employeeExport(data) {
  return fetch({
    url:BASE_API + '/employee/export',
    method: 'post',
    data
  })
}
//评审员列表
export function hrEmployeeReviewerList(data) {
  return fetch({
    url:BASE_API + '/hrEmployeeReviewer/listForPage',
    method: 'post',
    data
  })
}
//评审员修改查询
export function getByEmployeeId(params) {
  return fetch({
    url:BASE_API + '/hrEmployeeReviewer/getByEmployeeId'+"/"+params,
    method: 'get',
    // data
  })
}
//评审员列表
export function saveEmployeeReviewerAdd(data) {
  return fetch({
    url:BASE_API + '/hrEmployeeReviewer/saveEmployeeReviewer',
    method: 'post',
    data
  })
}
//评审员列表查看专业信息
export function showEmployeeId(params) {
  return fetch({
    url:BASE_API + '/hrEmployeeReviewer/showEmployeeId'+"/"+params,
    method: 'get',
    // data
  })
}
//评审员备案列表
export function listReviewerMajorList(data) {
  return fetch({
    url:BASE_API + '/hrEmployeeReviewer/listReviewerMajor',
    method: 'post',
    data
  })
}



//项目经历添加
export function saveReviewerWorkAdd(data) {
  return fetch({
    url:BASE_API + '/hrEmployeeReviewerWork/saveReviewerWork',
    method: 'post',
    data
  })
}
//项目经历查看
export function hrEmployeeReviewerWorkGet(params) {
  return fetch({
    url:BASE_API + '/hrEmployeeReviewerWork/get'+"/"+params,
    method: 'get',
    // data
  })
}
//项目经历列表
export function hrEmployeeReviewerWorkList(data) {
  return fetch({
    url:BASE_API + '/hrEmployeeReviewerWork/list',
    method: 'post',
    data
  })
}
//项目经历修改
export function hrEmployeeReviewerWorkEdit(data) {
  return fetch({
    url:BASE_API + '/hrEmployeeReviewerWork/updateEmployeeSchool',
    method: 'post',
    data
  })
}
//项目经历删除
export function hrEmployeeReviewerWorkDel(params) {
  return fetch({
    url:BASE_API + '/hrEmployeeReviewerWork/delete'+"/"+params,
    method: 'get',
    // data
  })
}
//评审员添加
export function addCustomerInfo(data) {
  return fetch({
    url:BASE_API + '/customer/addCustomerInfo',
    method: 'post',
    data
  })
}
//添加客户行业信息 及 证书
export function addCustomerIndustry(data) {
  return fetch({
    url:BASE_API + '/customer/addCustomerIndustry',
    method: 'post',
    data
  })
}

//评审员添加
export function findIndustryList(data) {
  return fetch({
    url:BASE_API + '/customer/findIndustryList',
    method: 'post',
    data
  })
}
export function competentAuthorityList(params) {
  return fetch({
    url:BASE_API + '/competentAuthority/list',
    method: 'get',
    params
  })
}
//企业联系人列表
export function forCustomerContactList(data) {
  return fetch({
    url:BASE_API + '/customer/listForCustomerContact',
    method: 'post',
    data
  })
}
//企业联系人添加
export function addCustomerContact(data) {
  return fetch({
    url:BASE_API + '/customer/addCustomerContact',
    method: 'post',
    data
  })
}
//企业联系人编辑
export function editCustomerContact(data) {
  return fetch({
    url:BASE_API + '/customer/editCustomerContact',
    method: 'post',
    data
  })
}
//企业联系人删除
export function deleteCustomerContact(data) {
  return fetch({
    url:BASE_API + '/customer/deleteCustomerContact',
    method: 'post',
    data
  })
}
//企业联系人查看
export function getCustomerContactById(data) {
  return fetch({
    url:BASE_API + '/customer/getCustomerContactById',
    method: 'post',
    data
  })
}

//企业办公地址列表
export function officeAddressList(data) {
  return fetch({
    url:BASE_API + '/customer/listForCustomerOfficeAddress',
    method: 'post',
    data
  })
}
//企业办公地址添加
export function officeAddressAdd(data) {
  return fetch({
    url:BASE_API + '/customer/addCustomerOfficeAddress',
    method: 'post',
    data
  })
}
//企业办公地址编辑
export function officeAddressEdit(data) {
  return fetch({
    url:BASE_API + '/customer/editCustomerOfficeAddress',
    method: 'post',
    data
  })
}
//企业办公地址删除
export function officeAddressDel(data) {
  return fetch({
    url:BASE_API + '/customer/deleteCustomerOfficeAddress',
    method: 'post',
    data
  })
}
//企业办公地址查看
export function officeAddressGet(data) {
  return fetch({
    url:BASE_API + '/customer/getCustomerOfficeAddressById',
    method: 'post',
    data
  })
}

//企业银行账户列表
export function forCustomerBankList(data) {
  return fetch({
    url:BASE_API + '/customer/listForCustomerBank',
    method: 'post',
    data
  })
}
//企业银行账户添加
export function customerBankAdd(data) {
  return fetch({
    url:BASE_API + '/customer/addCustomerBank',
    method: 'post',
    data
  })
}
//企业银行账户编辑
export function customerBankEdit(data) {
  return fetch({
    url:BASE_API + '/customer/editCustomerBank',
    method: 'post',
    data
  })
}
//企业银行账户删除
export function customerBankDel(data) {
  return fetch({
    url:BASE_API + '/customer/deleteCustomeBank',
    method: 'post',
    data
  })
}
//企业银行账户查看
export function customerBankGet(data) {
  return fetch({
    url:BASE_API + '/customer/getCustomerBankById',
    method: 'post',
    data
  })
}
//查询员工默认的开票信息
export function billingInformation(data) {
  return fetch({
    url:BASE_API + '/customer/getCustomerInvoiceByCustomerId',
    method: 'post',
    data
  })
}
// 编辑默认开票信息
export function billingInformationEdit(data) {
  return fetch({
    url:BASE_API + '/customer/updateCustomerInvoiceByCustomerId',
    method: 'post',
    data
  })
}
// 查询负责人信息--不分页
export function listForPrincipal(data) {
  return fetch({
    url:BASE_API + '/customer/listForPrincipal',
    method: 'post',
    data
  })
}
//添加业务跟踪记录（或客户移交）
export function addCustomerTrack(data) {
  return fetch({
    url:BASE_API + '/customer/addCustomerTrack',
    method: 'post',
    data
  })
}
//业务跟踪事件查看
export function getCustomerTrackById(data) {
  return fetch({
    url:BASE_API + '/customer/getCustomerTrackById',
    method: 'post',
    data
  })
}
//业务跟踪事件列表
export function forCustomerTrackPageList(data) {
  return fetch({
    url:BASE_API + '/customer/listForCustomerTrackPage',
    method: 'post',
    data
  })
}
//业务跟踪事件修改
export function editCustomerTrack(data) {
  return fetch({
    url:BASE_API + '/customer/editCustomerTrack',
    method: 'post',
    data
  })
}
//业务跟踪事件删除
export function deleteCustomerTrack(data) {
  return fetch({
    url:BASE_API + '/customer/deleteCustomerTrack',
    method: 'post',
    data
  })
}

//查询企业或企业信用代码是否存在
export function isCustomerExist(data) {
  return fetch({
    url:BASE_API + '/customer/isCustomerExist',
    method: 'post',
    data
  })
}
// 查看企业合同记录列表（分页）
export function listForContractPage(data) {
  return fetch({
    url:BASE_API + '/customer/listForCustomerContractPage',
    method: 'post',
    data
  })
}



// 登录方法
export function login(username, password) {
  const data = {
    username,
    password,
  }
  return fetch({
    url:BASE_API + '/login',
    method: 'post',
    data: data
  })
}

// 获取用户详细信息
export function getInfo() {
  return fetch({
    url:BASE_API + '/getInfo',
    method: 'get'
  })
}

// 退出方法
export function logout() {
  return fetch({
    url:BASE_API +'/logout',
    method: 'get'
  })
}


export function addTransferContract(data) {
  return fetch({
    url:BASE_API + '/contract/addTransferContract',
    method: 'post',
    data
  })
}




// WEBPACK FOOTER //
// ./src/api/login.js